import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Types } from "Types";
import { Selectors as DossierLocationSelectors } from "../../../redux/DossierLocation";
import {
  Selectors as BienSelectors,
  preremplirFormulaire,
} from "../../../redux/Bien";
import {
  useGetBien,
  useGetNombrePieces,
  useGetTypeBien,
  usePostBien,
  usePutBien,
} from "../../../hooks/Bien";
import {
  useDupliquerDossier,
  usePostDossierLocation,
  usePutDossierLocation,
} from "../../../hooks/DossierLocation";
import {
  useGetCommunes,
  useGetListTypeVoie,
} from "../../../hooks/Localisation";
import { Bien, BienDetail, Commune } from "../../../services/Api/swagger";
import {
  buildDossierLocation,
  buildFormBien,
  copyBienFormToModel,
  IBienFormData,
} from "./helpers";
import { useDispatch } from "react-redux";
import { useDataBien } from "./datas";
import { ParcoursLocataire } from "./ChoixParcoursForm";

export const useBienPage = () => {
  const {
    utilisateurConnecte,
    adbDetail,
    adbId,
    selectedSite,
    oldDossierLocation,
    modifBienData,
    bienDataFormEnCours,
  } = useDataBien();
  const {
    data: alreadyExistBien,
    isLoading: bienFetching,
    error: bienError,
    mutate: lancerChargementBien,
    reset: resetBien,
  } = useGetBien();

  // console.log(bienDataFormEnCours);
  const [bienData, setBienData] = useState<BienDetail | Bien>();
  // const bienData = state.bien.data ? state.bien.data : modifBienData;
  useEffect(() => {
    if (modifBienData) {
      setBienData(modifBienData);
    } else {
      setBienData(bienDataFormEnCours);
    }
  }, [modifBienData, bienDataFormEnCours]);

  useEffect(() => {
    if (alreadyExistBien) {
      const buildBien = preremplirFormulaire(alreadyExistBien);
      setBienData(buildBien);
    }
  }, [alreadyExistBien]);
  const {
    data: nombrePieces,
    isFetching: nombrePiecesFetching,
    error: nombrePiecesError,
    refetch: refetchNombrePieces,
  } = useGetNombrePieces();

  const {
    data: typesBien,
    isFetching: typesBiensFetching,
    error: typesBiensError,
    refetch: refetchTypesBien,
    remove: resetTypesBien,
  } = useGetTypeBien();

  const {
    data: typesVoie,
    isFetching: typeVoieFetching,
    error: typeVoieError,
    refetch: refetchTypesVoie,
  } = useGetListTypeVoie();

  const retryFetchingListe = () => {
    refetchNombrePieces();
    refetchTypesBien();
    refetchTypesVoie();
  };
  const { data: communes, mutate: getCommunes } = useGetCommunes();

  const chargerCommunes = (commune: Commune) => {
    getCommunes(commune);
  };
  const statutDossier = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getStatutDossier(state)
  );
  const dossierDuplique = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getDossierDuplique(state)
  );

  const {
    mutate: getDupliquerDossier,
    isLoading: duplicationFetching,
    error: duplicationError,
  } = useDupliquerDossier();

  const isModification = !!modifBienData;
  const initialValues = buildFormBien(
    bienData,
    isModification,
    !!oldDossierLocation?.parcoursCandidatLocataire,
    dossierDuplique
  );

  // const {
  //   mutate: putBien,
  //   reset: resetPutBien,
  //   error: errorPutBien,
  // } = usePutBien();

  const {
    mutate: postDossierLocation,
    isLoading: isLoadingPost,
    error: errorPostBien,
    reset: resetPostBien,
  } = usePostDossierLocation();

  const {
    mutate: putDossierLocation,
    isLoading: isLoadingPut,
    error: errorPutBien,
    reset: resetPutBien,
  } = usePutDossierLocation();
  const ajouterBien = (bien: IBienFormData) => {
    const bienModel = copyBienFormToModel(bien);
    const { choixParcours, candidatLocataire, ...bienForm } = bien;
    const dossierLocation = buildDossierLocation(
      oldDossierLocation,
      selectedSite,
      adbDetail,
      adbId,
      utilisateurConnecte,
      choixParcours,
      candidatLocataire
    );
    dossierLocation &&
      postDossierLocation({ ...dossierLocation, bien: bienModel });
    // postBien({ bien });
  };
  const modifierBien = (bien: IBienFormData) => {
    const bienModel = copyBienFormToModel(bien);

    const { choixParcours, candidatLocataire, ...bienForm } = bien;
    const dossierLocation = buildDossierLocation(
      oldDossierLocation,
      selectedSite,
      adbDetail,
      adbId,
      utilisateurConnecte,
      choixParcours,
      candidatLocataire
    );
    if (bienData) {
      bienModel.identifiant = bienData.identifiant;
      // @ts-ignore
      putDossierLocation({ ...dossierLocation, bien: bienModel });
    }
  };

  const preRemplirBien = (referenceMandat: string, numeroLot: string) => {
    lancerChargementBien({ referenceMandat, numeroLot });
  };

  const dupliquerDossier = (bien: IBienFormData) => {
    const bienModel = copyBienFormToModel(bien);
    dossierDuplique &&
      getDupliquerDossier({ ref: dossierDuplique, bien: bienModel });
  };

  // const dispatch = useDispatch();
  const supprimerErrorBien = () => {
    resetPostBien();
    resetPutBien();
  };

  const canSeeParcoursLocataire =
    adbDetail?.habilitations?.parcoursCandidatLocataire;

  const findDossierPrincipal = oldDossierLocation?.dossiersParticuliers?.find(
    (dp) => dp.principal
  );
  const dataParcoursLocataire: ParcoursLocataire | undefined =
    (oldDossierLocation?.parcoursCandidatLocataire && {
      nom: findDossierPrincipal?.nom,
      prenom: findDossierPrincipal?.prenom,
      email: findDossierPrincipal?.email,
      telephone: findDossierPrincipal?.telephonePortable,
    }) ||
    undefined;
  return {
    bienData,
    bienFetching,
    bienError,
    nombrePieces,
    nombrePiecesFetching,
    nombrePiecesError,
    typesBien,
    typesBiensFetching,
    typesBiensError,
    typesVoie,
    typeVoieFetching,
    typeVoieError,
    communes,
    chargerCommunes,
    statutDossier,
    dossierDuplique,
    dupliquerDossier,
    duplicationFetching,
    duplicationError,
    initialValues,
    retryFetchingListe,
    ajouterBien,
    modifierBien,
    preRemplirBien,
    supprimerErrorBien,
    errorPostBien,
    errorPutBien,
    oldDossierLocation,
    modifBienData,
    isLoadingPost,
    isModification,
    canSeeParcoursLocataire,
    dataParcoursLocataire,
  };
};
